export default {
  "web_area_data": [
    {
      "area_cd": "1",
      "area_nm": "アジア",
      "show_flg": "1"
    },
    {
      "area_cd": "6",
      "area_nm": "ミクロネシア",
      "show_flg": "1"
    },
    {
      "area_cd": "5",
      "area_nm": "ハワイ",
      "show_flg": "1"
    },
    {
      "area_cd": "3",
      "area_nm": "ヨーロッパ",
      "show_flg": "1"
    },
    {
      "area_cd": "11",
      "area_nm": "北米",
      "show_flg": "1"
    },
    {
      "area_cd": "7",
      "area_nm": "オセアニア",
      "show_flg": "1"
    },
    {
      "area_cd": "8",
      "area_nm": "南太平洋",
      "show_flg": null
    },
    {
      "area_cd": "12",
      "area_nm": "インド洋",
      "show_flg": null
    },
    {
      "area_cd": "10",
      "area_nm": "中南米",
      "show_flg": null
    },
    {
      "area_cd": "2",
      "area_nm": "中近東",
      "show_flg": "1"
    },
    {
      "area_cd": "4",
      "area_nm": "アフリカ",
      "show_flg": null
    }
  ],
  "country_list": {
    "1": [
      {
        "key": "19",
        "value": "韓国"
      },
      {
        "key": "21",
        "value": "台湾"
      },
      {
        "key": "7",
        "value": "タイ"
      },
      {
        "key": "20",
        "value": "香港"
      },
      {
        "key": "13",
        "value": "ベトナム"
      },
      {
        "key": "11",
        "value": "フィリピン"
      },
      {
        "key": "3",
        "value": "インドネシア"
      },
      {
        "key": "2",
        "value": "インド"
      },
      {
        "key": "5",
        "value": "シンガポール"
      },
      {
        "key": "15",
        "value": "マレーシア"
      },
      {
        "key": "22",
        "value": "中国"
      },
      {
        "key": "4",
        "value": "カンボジア"
      },
      {
        "key": "14",
        "value": "マカオ"
      },
      {
        "key": "8",
        "value": "ネパール"
      },
      {
        "key": "6",
        "value": "スリランカ"
      },
      {
        "key": "23",
        "value": "ウズベキスタン"
      },
      {
        "key": "28",
        "value": "キルギス"
      },
      {
        "key": "10",
        "value": "バングラデシュ"
      },
      {
        "key": "9",
        "value": "パキスタン"
      },
      {
        "key": "16",
        "value": "ミャンマー"
      },
      {
        "key": "17",
        "value": "モンゴル"
      },
      {
        "key": "18",
        "value": "ラオス"
      }
    ],
    "6": [
      {
        "key": "146",
        "value": "グアム"
      },
      {
        "key": "147",
        "value": "サイパン"
      },
      {
        "key": "150",
        "value": "パラオ共和国"
      }
    ],
    "5": [
      {
        "key": "139",
        "value": "オアフ島"
      },
      {
        "key": "142",
        "value": "ハワイ島"
      },
      {
        "key": "143",
        "value": "マウイ島"
      },
      {
        "key": "140",
        "value": "カウアイ島"
      },
      {
        "key": "145",
        "value": "ラナイ島"
      }
    ],
    "3": [
      {
        "key": "47",
        "value": "イタリア"
      },
      {
        "key": "64",
        "value": "フランス"
      },
      {
        "key": "57",
        "value": "スペイン"
      },
      {
        "key": "60",
        "value": "ドイツ"
      },
      {
        "key": "46",
        "value": "イギリス"
      },
      {
        "key": "63",
        "value": "フィンランド"
      },
      {
        "key": "53",
        "value": "ギリシャ"
      },
      {
        "key": "54",
        "value": "クロアチア"
      },
      {
        "key": "58",
        "value": "チェコ"
      },
      {
        "key": "50",
        "value": "オーストリア"
      },
      {
        "key": "55",
        "value": "スイス"
      },
      {
        "key": "51",
        "value": "オランダ"
      },
      {
        "key": "67",
        "value": "ベルギー"
      },
      {
        "key": "52",
        "value": "カザフスタン"
      },
      {
        "key": "69",
        "value": "ポルトガル"
      },
      {
        "key": "62",
        "value": "ハンガリー"
      },
      {
        "key": "61",
        "value": "ノルウェー"
      },
      {
        "key": "80",
        "value": "マルタ"
      },
      {
        "key": "81",
        "value": "アイスランド"
      },
      {
        "key": "45",
        "value": "アイルランド"
      },
      {
        "key": "48",
        "value": "ウクライナ"
      },
      {
        "key": "49",
        "value": "エストニア"
      },
      {
        "key": "56",
        "value": "スウェーデン"
      },
      {
        "key": "79",
        "value": "スロバキア"
      },
      {
        "key": "82",
        "value": "スロヴェニア"
      },
      {
        "key": "59",
        "value": "デンマーク"
      },
      {
        "key": "65",
        "value": "ブルガリア"
      },
      {
        "key": "68",
        "value": "ポーランド"
      },
      {
        "key": "72",
        "value": "ラトビア"
      },
      {
        "key": "73",
        "value": "リトアニア"
      },
      {
        "key": "74",
        "value": "ルーマニア"
      },
      {
        "key": "75",
        "value": "ルクセンブルク"
      }
    ],
    "11": [
      {
        "key": "205",
        "value": "アメリカ西部"
      },
      {
        "key": "206",
        "value": "アメリカ東部"
      },
      {
        "key": "204",
        "value": "カナダ"
      }
    ],
    "7": [
      {
        "key": "158",
        "value": "オーストラリア"
      },
      {
        "key": "157",
        "value": "ニュージーランド"
      },
      {
        "key": "156",
        "value": "パプアニューギニア"
      }
    ],
    "8": [
      {
        "key": "163",
        "value": "ニューカレドニア"
      },
      {
        "key": "164",
        "value": "タヒチ"
      },
      {
        "key": "162",
        "value": "フィジー"
      }
    ],
    "12": [
      {
        "key": "207",
        "value": "モルディブ"
      },
      {
        "key": "208",
        "value": "セイシェル"
      },
      {
        "key": "209",
        "value": "モーリシャス"
      }
    ],
    "10": [
      {
        "key": "198",
        "value": "ペルー"
      },
      {
        "key": "200",
        "value": "メキシコ"
      },
      {
        "key": "195",
        "value": "ブラジル"
      },
      {
        "key": "184",
        "value": "アルゼンチン"
      },
      {
        "key": "191",
        "value": "チリ"
      },
      {
        "key": "197",
        "value": "ベリーズ"
      },
      {
        "key": "199",
        "value": "ボリビア"
      }
    ],
    "2": [
      {
        "key": "29",
        "value": "アラブ首長国連邦"
      },
      {
        "key": "38",
        "value": "トルコ"
      },
      {
        "key": "33",
        "value": "カタール"
      },
      {
        "key": "43",
        "value": "オマーン"
      }
    ],
    "4": [
      {
        "key": "116",
        "value": "モロッコ"
      },
      {
        "key": "95",
        "value": "エジプト"
      },
      {
        "key": "119",
        "value": "南アフリカ共和国"
      }
    ]
  }
}
